module.exports = __webpack_public_path__ + "static/media/1.b05c093c.png";